export default __webpack_public_path__ + "static/media/430925__higgs01__yipee.8fe682f9.mp3";